export const operationDepsKeys = {
  get: (workOrderId: string) => ["operationDeps", workOrderId] as const,
};
